import { get } from "../services/apiParceiro";
import { TextField } from "@mui/material";
import { apenasNumeros } from "@/services/utils";
import { formataCpfCnpj } from "@/services/document";
import { validaCpfCnpj } from "../services/document";
import { getArea } from "../services/ambiente";
import { useDispatch } from "react-redux";
import {
  activeSpinner,
  cancelSpinner,
  setInfoToaster,
} from "../store/reducers/geral";

export default function InputCpfCnpj({
  label,
  formik,
  searchClientData,
  setUsuarioJaCadastrado,
  disabled,
}) {
  const dispatch = useDispatch();

  const handleChangeCpfCnpj = async (valor) => {
    formik.setFieldValue("cpfCnpj", formataCpfCnpj(valor));
    const cpfCnpj = apenasNumeros(valor);

    if (cpfCnpj.length > 11) {
      formik.setFieldValue("cpf", "");
      formik.setFieldValue("cnpj", valor);
      formik.setFieldValue("personType", "PJ");
    } else {
      formik.setFieldValue("cnpj", "");
      formik.setFieldValue("cpf", valor);
      formik.setFieldValue("personType", "PF");
    }
  };

  const handleChangeCpf = async () => {
    setUsuarioJaCadastrado(false);

    const cpfCnpj = apenasNumeros(formik.values.cpfCnpj);
    const cpfValido = validaCpfCnpj(cpfCnpj);
    if (getArea() !== "parceiro" || !cpfValido) {
      return;
    }

    dispatch(activeSpinner());
    try {
      const result = await get(`secure/user/verify-client-register/${cpfCnpj}`);
      dispatch(cancelSpinner());
      if (!!result) {
        formik.setValues({
          ...formik.values,
          cpfCnpj: result.cpf,
          cpf: result.cpf,
          cnpj: result.cnpj,
          email: result.email,
          whatsapp: result.whatsapp,
          province: result.province,
          zipCode: result.zipCode,
          street: result.street,
          number: result.number,
          complement: result.complement,
          neighborhood: result.neighborhood,
          city: result.city,
          name: result.name,
          personType: result.personType,
        });
        dispatch(
          setInfoToaster({
            open: true,
            message:
              "Usuário já cadastrado. Os dados foram preenchidos automaticamente.",
            type: "success",
          })
        );
        setUsuarioJaCadastrado(true);
      }
    } catch (e) {
      console.log(e);
      dispatch(cancelSpinner());
    }
  };

  return (
    <TextField
      fullWidth
      label={label || "CPF ou CNPJ *"}
      name="cpfCnpj"
      value={formik.values.cpfCnpj || ""}
      variant="outlined"
      error={formik.touched.cpfCnpj && Boolean(formik.errors.cpfCnpj)}
      helperText={formik.touched.cpfCnpj && formik.errors.cpfCnpj}
      onChange={(valor) => {
        handleChangeCpfCnpj(valor.target.value);
      }}
      onBlur={() => {
        if (searchClientData) {
          handleChangeCpf();
        }
      }}
      slotProps={{
        input: {
          maxLength: 18,
          readOnly: disabled,
        },
      }}
    />
  );
}
